import { useEffect, useState, useCallback } from 'react'
import { wineClubApi } from '../../api/wineClub'
import { colors, font } from '../../design/tokens'
import { Cargando, ErrorMsg, Titulo, fmtMoney, BotonPrimario, Seccion } from './comunes'

// Wine Club en el celular (Martin, 31 ago 2026): ver los niveles con sus
// precios (los que cobra Mobbex) y CAMBIARLOS. Es la misma operación que en
// CLIENTES → Wine Club: se escribe en la suscripción de Mobbex y rige también
// en la web. La gestión de socios sigue en el escritorio.
export default function MovilWineClub() {
  const [niveles, setNiveles] = useState(null)
  const [error, setError] = useState(null)
  const [editando, setEditando] = useState(null)
  const [valor, setValor] = useState('')
  const [ocupado, setOcupado] = useState(false)
  const [msg, setMsg] = useState(null)

  const [resumen, setResumen] = useState(null)

  const cargar = useCallback(async () => {
    try {
      const { data } = await wineClubApi.niveles()
      setNiveles(data.niveles)
      setError(null)
    } catch (e) {
      setError(e.response?.data?.error || 'No se pudieron cargar los niveles')
    }
    try {
      const { data } = await wineClubApi.socios({ estado: 'todos' })
      setResumen(data.resumen)
    } catch { /* el resumen es secundario: sin él, la pantalla sigue sirviendo */ }
  }, [])

  useEffect(() => { cargar() }, [cargar])

  const guardar = async (n) => {
    const precio = Number(String(valor).replace(/\./g, '').replace(',', '.'))
    if (!precio || precio <= 0) { setMsg({ ok: false, texto: 'Ingresá un precio válido' }); return }
    if (!window.confirm(`¿Cambiar el precio de ${n.nombre} de ${fmtMoney(n.precio)} a ${fmtMoney(precio)}? Es el precio de la suscripción en Mobbex para todos sus socios.`)) return
    setOcupado(true); setMsg(null)
    try {
      const { data } = await wineClubApi.precio(n.nivel, precio)
      setNiveles(data.niveles)
      setEditando(null); setValor('')
      setMsg({ ok: true, texto: `${n.nombre} actualizado.` })
    } catch (e) {
      setMsg({ ok: false, texto: e.response?.data?.error || 'No se pudo cambiar el precio' })
    } finally { setOcupado(false) }
  }

  return (
    <div>
      <Titulo>Wine Club · precios</Titulo>
      <p style={{ margin: '4px 0 12px', fontSize: 12.5, color: colors.textSec, fontFamily: font.sans }}>
        El precio vive en Mobbex (es lo que se cobra) y rige también en la web. Los socios se gestionan desde LGR completo.
      </p>
      {error && <ErrorMsg>{error}</ErrorMsg>}
      {!niveles && !error && <Cargando />}
      {(niveles || []).map((n) => (
        <div key={n.nivel} style={cardNivel}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontFamily: font.sans, fontWeight: 600, fontSize: 16, color: colors.text }}>{n.nombre}</span>
            <span style={{ fontSize: 12, color: colors.textSec, fontFamily: font.sans }}>{n.activos} activos</span>
          </div>
          {editando === n.nivel ? (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
              <span style={{ color: colors.textSec }}>$</span>
              <input
                autoFocus value={valor} inputMode="numeric"
                onChange={(e) => setValor(e.target.value)}
                style={inputPrecio} disabled={ocupado}
              />
              <button style={btnChico} disabled={ocupado} onClick={() => guardar(n)}>{ocupado ? '…' : 'Guardar'}</button>
              <button style={{ ...btnChico, background: colors.bg, color: colors.textSec }} disabled={ocupado} onClick={() => { setEditando(null); setMsg(null) }}>✕</button>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
              <span style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 19, fontWeight: 700, color: n.precio == null ? colors.err : colors.text }}>
                {n.precio == null ? 'Sin dato' : `${fmtMoney(n.precio)} / mes`}
              </span>
              {n.precio != null && (
                <button style={btnChico} onClick={() => { setEditando(n.nivel); setValor(String(Math.round(n.precio))); setMsg(null) }}>Editar</button>
              )}
            </div>
          )}
        </div>
      ))}
      {msg && <p style={{ fontSize: 13, fontFamily: font.sans, fontWeight: 600, color: msg.ok ? '#16a34a' : colors.err }}>{msg.texto}</p>}

      {resumen && (
        <Seccion titulo="Miembros por nivel">
          <div style={{ display: 'flex', gap: 8, padding: '2px 0 6px', borderBottom: `1px solid ${colors.borderSoft}` }}>
            <span style={{ flex: 1 }} />
            <span style={cabecera}>Activos</span>
            <span style={cabecera}>Pausados</span>
          </div>
          {(resumen.por_nivel || []).map((n) => (
            <div key={n.nivel} style={{ display: 'flex', gap: 8, alignItems: 'baseline', padding: '6px 0', borderBottom: `1px solid ${colors.borderSoft}` }}>
              <span style={{ flex: 1, fontFamily: font.sans, fontSize: 13.5, color: colors.text }}>{n.nombre}</span>
              <span style={celda}>{n.activos}</span>
              <span style={{ ...celda, color: n.pausados > 0 ? colors.textSec : colors.textMeta }}>{n.pausados ?? '—'}</span>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8, alignItems: 'baseline', padding: '7px 0 0' }}>
            <span style={{ flex: 1, fontFamily: font.sans, fontSize: 13.5, fontWeight: 700, color: colors.text }}>Total</span>
            <span style={{ ...celda, fontWeight: 700 }}>{resumen.activos}</span>
            <span style={{ ...celda, fontWeight: 700, color: colors.textSec }}>{resumen.pausados}</span>
          </div>
        </Seccion>
      )}

      <BotonPrimario onClick={cargar} style={{ marginTop: 10 }}>↻ Releer de Mobbex</BotonPrimario>
    </div>
  )
}

const cardNivel = {
  padding: '12px 14px', border: `1px solid ${colors.border}`, borderRadius: 12,
  background: colors.bg, marginBottom: 8,
}
const cabecera = { width: 64, textAlign: 'right', fontSize: 10.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', color: colors.textSec, fontFamily: font.sans }
const celda = { width: 64, textAlign: 'right', fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 14, color: colors.text }
const inputPrecio = {
  flex: 1, minWidth: 0, padding: '8px 10px', borderRadius: 10,
  border: `1px solid ${colors.textPlh}`, fontSize: 15, fontFamily: font.mono, outline: 'none',
}
const btnChico = {
  padding: '8px 12px', borderRadius: 10, border: `1px solid ${colors.border}`,
  background: colors.text, color: colors.bg, fontSize: 13, fontWeight: 600,
  fontFamily: font.sans, cursor: 'pointer', flexShrink: 0,
}
